export type AuthErrorNavigationCode = 'SESSION_INVALID' | 'PERMISSION_DENIED'

const AUTH_ERROR_NAVIGATION_EVENT = 'lytstore:auth-error-navigation'
let pendingSessionValidation: Promise<boolean> | null = null

interface AuthErrorNavigationDetail {
  errorCode: AuthErrorNavigationCode
}

export function requestAuthErrorNavigation(errorCode: AuthErrorNavigationCode): void {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(
    new CustomEvent<AuthErrorNavigationDetail>(AUTH_ERROR_NAVIGATION_EVENT, {
      detail: { errorCode },
    })
  )
}

export function onAuthErrorNavigation(
  handler: (errorCode: AuthErrorNavigationCode) => void
): () => void {
  if (typeof window === 'undefined') {
    return () => {}
  }

  const listener: EventListener = (event) => {
    const customEvent = event as CustomEvent<AuthErrorNavigationDetail>
    const errorCode = customEvent?.detail?.errorCode
    if (!errorCode) {
      return
    }
    handler(errorCode)
  }

  window.addEventListener(AUTH_ERROR_NAVIGATION_EVENT, listener)
  return () => window.removeEventListener(AUTH_ERROR_NAVIGATION_EVENT, listener)
}

async function checkSessionValidity(): Promise<boolean> {
  const response = await fetch('/v1/admin/auth/check', {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  })

  if (!response.ok) {
    return false
  }

  const payload = await response.json().catch(() => null)
  return payload?.data?.valid === true
}

export async function shouldRedirectForUnauthorized(): Promise<boolean> {
  if (pendingSessionValidation) {
    return pendingSessionValidation
  }

  pendingSessionValidation = checkSessionValidity()
    .then((valid) => !valid)
    .catch(() => true)
    .finally(() => {
      pendingSessionValidation = null
    })

  return pendingSessionValidation
}
